import Vue from 'vue'

const resource = 'meetings'
const buildExpectedStatusPayload = expectedStatus => expectedStatus ? {expected_status: expectedStatus} : {}

const get = (params = {}) => Vue.axios.get(`${resource}`, {params})
const getById = (id, key = null) => Vue.axios.get(`${resource}/${id}?key=${key}`)
const store = meeting => Vue.axios.post(`${resource}`, meeting)
const update = (id, data) => Vue.axios.put(`${resource}/${id}`, data)
const cancel = (id, message = null, cancel_type, expectedStatus = null) => {
  const payload = {message, cancel_type, ...buildExpectedStatusPayload(expectedStatus)}
  return Vue.axios.post(`${resource}/${id}/cancel`, payload)
}
const accept = (id, expectedStatus = null) => {
  const payload = buildExpectedStatusPayload(expectedStatus)
  return Vue.axios.post(`${resource}/${id}/approve`, payload)
}
const join = id => Vue.axios.post(`${resource}/${id}/join`)
const createInvoice = (meetingId, headers = {}, params = {}) => Vue.axios.get(`${resource}/${meetingId}/invoice/create`, {headers}, {params})
const getInvoiceDetail = (meetingId, headers = {}) => Vue.axios.get(`${resource}/${meetingId}/invoice`, {headers})
const editPaymentMethod = (meetingId, headers = {}) => Vue.axios.get(`${resource}/${meetingId}/payment-method`, {headers})
const editShippingAddress = (meetingId, headers = {}) => Vue.axios.get(`${resource}/${meetingId}/address`, {headers})

export default {
  get,
  getById,
  store,
  update,
  cancel,
  accept,
  join,
  createInvoice,
  getInvoiceDetail,
  editPaymentMethod,
  editShippingAddress
}



// WEBPACK FOOTER //
// ./src/api/meeting.js